/// <amd-module name="Test/TestPlansHubRefresh/Pivots/AuthorPivot/TestCaseItemsSortingUtility" />
import * as AuthorConstants from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/AuthorConstants";
import { ITestCaseItem } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorContracts";

/**
 * Custom sorting utility to sort columns in author tab.
 * @param columnId - Id of the the column on which sorting has to be applied
 * @param sortOrder - Sort Order of the column (asc / desc)
 */
export const getTestCaseItemsComparator = function(columnId: string, sortOrder: number | undefined) {
    // set reverse to invert function comparator if sortOrder is changed
    const reverse: number = sortOrder === 0 || sortOrder === undefined ? 1 : -1;

    if (columnId === AuthorConstants.OrderColumn) {
        return (a: ITestCaseItem, b: ITestCaseItem) => {
            return reverse * (a.order - b.order);
        };
    }

    if (columnId === AuthorConstants.NameColumn) {
        return (a: ITestCaseItem, b: ITestCaseItem) => {
            return reverse * a.name.localeCompare(b.name, navigator.language);
        };
    }

    if (columnId === AuthorConstants.AssignedToColumn) {
        return (a: ITestCaseItem, b: ITestCaseItem) => {
            return reverse * a.assignedTo.displayName.localeCompare(b.assignedTo.displayName, navigator.language);
        };
    }

    if (columnId === AuthorConstants.StateColumn) {
        return (a: ITestCaseItem, b: ITestCaseItem) => {
            return reverse * a.state.localeCompare(b.state, navigator.language);
        };
    }

    if (columnId === AuthorConstants.TestCaseIdColumn) {
        return (a: ITestCaseItem, b: ITestCaseItem) => {
            return reverse * (a.id - b.id);
        };
    }

    if (columnId) {
        return (a: ITestCaseItem, b: ITestCaseItem) => {
            const columnValueA = a.columnOptionValues[columnId];
            const columnValueB = b.columnOptionValues[columnId];

            return reverse * (columnValueA > columnValueB ? 1 : columnValueA == columnValueB ? 0 : -1);
        };
    }
};
